import React from 'react';
import Herosection from "../Homepage/Herosection"
import About from './About';
import Reasons from './Reasons';
import Services from '../layouts/Ourservices';
import ServicesShowcase from '../layouts/ServiceShowcase';
import Faq from '../layouts/Faqs';
import Testimonials from '../layouts/Testimonials';
import HeroCta from '../layouts/HeroCta';
import ClientsStrip from '../layouts/ClientsStrip';
import PartnersSection from "../layouts/PartnersSection";

const Homepage = () => {
  return (
    <div className='avena-homepage'>
        <Herosection />
        <About />
        <ClientsStrip />
        <PartnersSection />
           <Reasons />
           <ServicesShowcase />
           <HeroCta />
            <Services />
           <Faq />
           <Testimonials />
       
     
      
    </div>
  )
}

export default Homepage
